import { getIn } from 'final-form';
import { useEffect } from 'react';
import { useForm } from 'react-final-form';

// Fixes RFF's default parse turning '' into undefined. Remounted fields then treated
// undefined as unset and re-apply initialValue, restoring the original.
// Only dirty fields can have been cleared, so untouched entries are never visited.
export function usePersistClearedFormFieldValues() {
  const form = useForm();

  useEffect(
    () =>
      form.subscribe(
        ({ dirtyFields, values }) => {
          form.batch(() => {
            Object.keys(dirtyFields).forEach((name) => {
              const value = getIn(values, name);
              if (value === undefined || value === '') {
                form.change(name, null);
              }
            });
          });
        },
        { dirtyFields: true, values: true },
      ),
    [form],
  );
}
